<template>
  <div class="form-group">
    <slot></slot>
  </div>
</template>
